/**
 * 베타 모드 상태 hook (마이그 092, 2026-05-22).
 *
 * /api/features/beta-status 호출 — 5분 in-process cache (모든 컴포넌트 공유).
 * frontend 의 베타 정책 영역 (구독 카드, 구독 관리 link 등) 이 이 hook 으로 자동 분기.
 *
 * 사용:
 *   const beta = useBetaStatus();
 *   const betaEnded = beta && !beta.beta_active;
 *   {betaEnded && <SubscriptionCard />}
 */
import { useEffect, useState } from "react";
import axios from "axios";

export interface BetaStatus {
  beta_active: boolean;
  start_date: string;
  end_date: string;
  auto_tier: string;
  grace_days: number;
  days_remaining: number;   // end_date - today (음수 = 만료됨)
  grace_remaining: number;  // end_date + grace_days - today
  updated_at: string;
}

let _cache: { data: BetaStatus | null; ts: number } = { data: null, ts: 0 };
const TTL = 5 * 60 * 1000; // 5분 — 어드민이 토글 후 최대 5분 안에 사용자 화면 반영

export function useBetaStatus(): BetaStatus | null {
  const [data, setData] = useState<BetaStatus | null>(_cache.data);
  useEffect(() => {
    const now = Date.now();
    if (_cache.data && now - _cache.ts < TTL) {
      setData(_cache.data);
      return;
    }
    axios
      .get<BetaStatus>("/api/features/beta-status")
      .then((r) => {
        _cache = { data: r.data, ts: now };
        setData(r.data);
      })
      .catch(() => setData(null));
  }, []);
  return data;
}
